// extracted by mini-css-extract-plugin
module.exports = {"latestPhones":"phoneslider_latestPhones__3K_rn","phone":"phoneslider_phone__ZPlw-","title":"phoneslider_title__2ulPo"};